<template>
  <generic-popup v-model="profileUpdateRequiredPopupOpen" :title="$t('popup.profile-update-required.title')" :text="$t('popup.profile-update-required.text')" :is-closable="false">
    <div class="button-container">
      <router-link class="update-required-button a-btn-primary" @click.native="profileUpdateRequired = false" :to="{ name: $consts.urls.URL_ACCOUNT_EDIT_INFORMATIONS }">
        {{ $t('popup.profile-update-required.button') }}
      </router-link>
      <button class="update-required-button a-btn-primary" @click="logout">
        {{ $t('popup.profile-update-logout.button') }}
      </button>
    </div>
  </generic-popup>
</template>

<script>
import GenericPopup from '@/components/popup/generic-popup'
import UserService from '@/services/user'
import AuthentificationService from '@/services/authentification'
import { CLAIM_UTYPE_SYSTEMADMIN } from '@/consts/claims'

export default {
  components: {
    GenericPopup
  },
  data() {
    return {
      profileUpdateRequired: false
    }
  },
  computed: {
    profileUpdateRequiredPopupOpen: {
      get() {
        return this.profileUpdateRequired && this.$route.name != this.$consts.urls.URL_ACCOUNT_EDIT_INFORMATIONS
      },
      set(value) {
        this.profileUpdateRequired = value
      }
    }
  },
  async beforeMount() {
    await this.checkIfProfileUpdateIsRequired()
  },
  methods: {
    async checkIfProfileUpdateIsRequired() {
      const localUser = await UserService.getLocalUser()
      if (localUser.type == CLAIM_UTYPE_SYSTEMADMIN) {
        this.profileUpdateRequired = false
      } else {
        const hasPhoneNumber = await UserService.hasPhoneNumber()
        this.profileUpdateRequired = !hasPhoneNumber
      }
    },
    logout() {
      AuthentificationService.logout()
    }
  },
  watch: {
    $route(to, from) {
      if (to.name != this.$consts.urls.URL_ACCOUNT_EDIT_INFORMATIONS) this.checkIfProfileUpdateIsRequired()
    }
  }
}
</script>

<style lang="scss">
.button-container {
  display: flex;
}

.update-required-button {
  margin: 10px;
}
</style>
